import { useState } from "react";

import Modal from "~/components/ui/modal";

import styles from "./index.module.scss";

type Props = {
  text: string;
  termsOfService?: boolean;
};

const ApplicationRulesOfSilencio = ({
  text,
  termsOfService = false,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <a
        // onClick={handleOpenModal}
        className={styles.applicationRulesOfSilencio}
        href={
          termsOfService
            ? "/termsOfService/Mentions-légales-Silencio.pdf"
            : "https://www.termsfeed.com/live/1d437bd4-aa46-4c95-8bf0-b670f1ed0a9c"
        }
        target="_blank"
        rel="noreferrer"
      >
        {text}
      </a>
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        showAnimation="fade-in"
      >
        <div className={styles.applicationRulesOfSilencioModal}>
          Lorem Ipsum
        </div>
      </Modal>
    </>
  );
};

export default ApplicationRulesOfSilencio;
